import React, { useEffect, useState } from "react";
import { ArrowRight, Clock, TrendingUp } from "lucide-react";
import ScoreGauge from "./ScoreGauge";
import { formatGain, getBadge } from "../data/questions";

const ResultScreen = ({ score, gainMinutes, onContinue }) => {
  const [visible, setVisible] = useState(false);
  const badge = getBadge(score);
  const annualHours = Math.round((gainMinutes * 220) / 60);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(t);
  }, []);

  const getDescription = () => {
    if (score >= 80)
      return "Votre entreprise est bien équipée numériquement. Quelques optimisations ciblées peuvent encore améliorer vos performances.";
    if (score >= 50)
      return "Vous avez un potentiel de progression significatif. Des actions ciblées vous permettraient de gagner sensiblement en efficacité.";
    return "Votre transformation numérique est prioritaire. Un accompagnement adapté peut avoir un impact rapide et mesurable.";
  };

  return (
    <div className="screen-container justify-center">
      <div
        className="content-wrapper"
        style={{
          opacity: visible ? 1 : 0,
          transform: visible ? "translateY(0)" : "translateY(20px)",
          transition: "opacity 0.5s ease, transform 0.5s ease",
        }}
      >
        {/* Header */}
        <div className="text-center mb-5">
        <img
            src="/logos._lbs_conecti.png"
            alt="Groupe LBS Conecti"
            style={{
              display: "block",
              margin: "0 auto",
              width: "100%",
              height: "auto",
            }}
          />
        </div>

        {/* Score card */}
        <div className="card p-8 text-center mb-4">
          <div className="flex justify-center mb-3">
            <ScoreGauge score={score} animate={true} />
          </div>

          <div
            data-testid="score-badge"
            className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full font-semibold text-sm mb-4"
            style={{
              backgroundColor: badge.bg,
              color: badge.color,
              fontFamily: "Montserrat, sans-serif",
            }}
          >
            {badge.label}
          </div>

          <p
            style={{
              fontFamily: "Inter, sans-serif",
              fontSize: 14,
              color: "#4A4A4A",
              lineHeight: 1.6,
            }}
          >
            {getDescription()}
          </p>
        </div>

        {/* Gain card */}
        <div className="card p-5 mb-3">
          <div className="flex items-center gap-4">
            <div
              style={{
                width: 48,
                height: 48,
                borderRadius: 12,
                backgroundColor: "#12354D",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <Clock size={22} color="#B5163A" />
            </div>
            <div>
              <p
                style={{
                  fontFamily: "Inter, sans-serif",
                  fontSize: 11,
                  color: "#9CA3AF",
                  textTransform: "uppercase",
                  letterSpacing: "0.08em",
                  marginBottom: 2,
                }}
              >
                Gain potentiel
              </p>
              <p
                data-testid="gain-display"
                style={{
                  fontFamily: "Montserrat, sans-serif",
                  fontWeight: 700,
                  fontSize: 26,
                  color: gainMinutes > 90 ? "#C62828" : "#12354D",
                }}
              >
                {formatGain(gainMinutes)} / jour
              </p>
            </div>
          </div>
        </div>

        {/* Annual projection */}
        {annualHours > 0 && (
          <div className="card p-4 mb-4">
            <div className="flex items-center gap-3">
              <TrendingUp size={18} color="#1F4E6D" />
              <p style={{ fontFamily: "Inter, sans-serif", fontSize: 13, color: "#4A4A4A" }}>
                Projection annuelle :{" "}
                <strong style={{ color: "#12354D" }}>
                  {annualHours} heures récupérées
                </strong>{" "}
                sur 220 jours ouvrés
              </p>
            </div>
          </div>
        )}

        <button
          data-testid="get-report-button"
          className="btn-primary"
          onClick={onContinue}
        >
          Recevoir mon rapport PDF
          <ArrowRight size={20} />
        </button>
      </div>
    </div>
  );
};

export default ResultScreen;
